import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { formatDiscountTitle } from '@modules/subscriptions/core/discountLabel';
import { PriceIcon } from '../icons';
import { formatMoney } from '@helpers/index';

export interface PriceDisplayProps {
  newPrice: number;
  currencyCode: string;
  discount: any;
}

// Converted from an implicit-return arrow to a block body so it can hold the
// useIntl hook the discount label needs.
export const PriceDisplay: React.FC<PriceDisplayProps> = ({ newPrice, currencyCode, discount }) => {
  const intl = useIntl();

  return (
    <div className="product-preview-step__section">
      <label className="product-preview-step__label">
        <PriceIcon />
        <FormattedMessage id="GLOBAL.PRICE" />
      </label>
      <div className="ppu-price-display">
        <div className="ppu-price-display__icon">
          <PriceIcon />
        </div>
        <div className="ppu-price-display__content">
          <span className="ppu-price-display__label">
            <FormattedMessage id="PET_PROFILE.PRICE.NEW_PER_DELIVERY" />
          </span>
          <div className="ppu-price-display__values">
            <span className="ppu-price-display__value">
              {formatMoney(newPrice, currencyCode, intl.locale)}
            </span>
            <span className="ppu-price-display__note">
              <FormattedMessage id="GLOBAL.INCL_VAT" />
            </span>
          </div>
          {discount && (
            <span className="ppu-price-display__discount">
              <FormattedMessage
                id="DISCOUNT.APPLIED"
                values={{
                  label:
                    formatDiscountTitle(intl, discount.title) ||
                    intl.formatMessage({ id: 'DISCOUNT.FALLBACK' }),
                }}
              />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
